export default "__VITE_ASSET__dab07007__"